<app-page-header title="Expected Bills"></app-page-header>
<nexus-grid [data]="expected_bill_model">
    <kendo-grid-column field="provider.name" title="Provider Name"></kendo-grid-column>
    <kendo-grid-column field="account_number" title="Account Number"></kendo-grid-column>
    <kendo-grid-column field="description" title="Description"></kendo-grid-column>
    <kendo-grid-column field="utilities_start_date" title="Utility Start Date" format="{0:MM/dd/yyyy}" filter="date"
    *ngIf="session.current_property.market.group_transitions_enabled"></kendo-grid-column>
    <kendo-grid-column field="id" title="" [filterable]="false" [sortable]="false" [width]="60">
        <ng-template kendoGridCellTemplate let-dataItem>
            <button kendoButton [svgIcon]="pencilIcon" [routerLink]="['/billing', 'expected-bills', dataItem.id]"></button>
        </ng-template>
    </kendo-grid-column>
</nexus-grid>